import { SearchInput } from 'ui-components';
import { CONTENT_SEARCH_PARAMS } from '~/hooks/useContentSearch';
import { convertPxToRems } from '~/utils-ts';

import { IContentSearchComponentProps } from '../ContentSearchFilter.types';

export const ContentSearchFilterSearch: React.FC<
  IContentSearchComponentProps
> = ({ filters: { query = '' }, onChange, order, trackId, isDisabled }) => {
  return (
    <SearchInput
      defaultValue={decodeURIComponent(query)}
      inputProps={{
        id: 'searchContentId',
        inputGroupProps: { width: convertPxToRems(194) },
        name: 'searchContent',
        onClear: () => onChange({ [CONTENT_SEARCH_PARAMS.query]: '' }),
        placeholder: 'Search by keywords',
        isDisabled: isDisabled,
        trackId: trackId,
        sx: {
          pointerEvents: isDisabled ? 'none' : 'auto',
        },
      }}
      onChange={(value) => onChange({ [CONTENT_SEARCH_PARAMS.query]: value })}
      order={order}
    />
  );
};
